

//import tool from "@/util/debounce.js"
// tool._debouncefont(function(){})

export default {
    //防抖 尾部执行
    _debounce(fn, delay){
       
        var delay = delay || 200;
        var timer;
        return function() {
            var th = this;
            var args = arguments;
            if (timer) {
                clearTimeout(timer);
            }
            timer = setTimeout(function() {
                timer = null;
                fn.apply(th, args);
            }, delay);
        };
    },
    //防抖首部执行
    _debouncefont(fn, delay){
        var last;
        var timer;
        var interval = delay || 200;
        return function() {
            var th = this;
            var args = arguments;
            var now = +new Date();
            if (last && now - last < interval) {
                last = now;
              
            } else {
                last = now;
                fn.apply(th, args);
            }
        }
    },
    // 节流  每delay的时间执行一次 
    _throttle(fn, interval) {
        var last;
        var timer;
        var interval = interval || 200;
        return function() {
            var th = this;
            var args = arguments;
            var now = +new Date();
            if (last && now - last < interval) {
                clearTimeout(timer);
                timer = setTimeout(function() {
                    last = now;
                    fn.apply(th, args);
                }, interval);
            } else {
                last = now;
                fn.apply(th, args);
            }
        }
    }
}